import axios from "axios";
import {
  Sonic_GetCountries_URL,
  Sonic_GetStates_URL,
  Sonic_GetCities_URL,
  Sonic_GetAreas_URL,
} from "./config";
import axiosApi from "../../src/api/axiosInstance";

export const CallCenterAPI = () => {
  const env_var = process.env.NODE_ENV;

  return {
    getCountries: (req, res) =>
      axios
        .get(Sonic_GetCountries_URL, { params: req })
        .then((response) => {
          res = response.data;
          return res;
        })
        .catch((err) => {
          console.log("Call Center API getCountries Error ");
        }),
    getStates: (req, res) =>
      axios
        .get(Sonic_GetStates_URL, { params: req })
        .then((response) => {
          res = response.data;
          return res;
        })
        .catch((err) => {
          console.log("Call Center API getStates Error: ");
        }),
    getCities: (req, res) =>
      axios
        .get(Sonic_GetCities_URL, { params: req })
        .then((response) => {
          res = response.data;
          //console.log("response from API call");
          //console.log(response.data);
          return res;
        })
        .catch((err) => {
          console.log("Call Center API getCities Error: ");
        }),
    getAreas: (req, res) =>
      axios
        .get(Sonic_GetAreas_URL, { params: req })
        .then((response) => {
          res = response.data;
          //console.log("response from API call");
          //console.log(res);
          return res;
        })
        .catch((err) => {}),
    sendEmailV2: async (payload) => {
      const { data } = await axiosApi.post(
        "/api/v2/public/contact-us",
        payload
      );
      return data; // { success, message }
    },
  };
};
